import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';

export interface InlineQuantityControlProps {
    name: string;
    value: number;
    onChange: (event: any) => void;
    //    Optional
    fullWidth?: boolean;
}

const useStyles = makeStyles(theme => ({
    input: {
        backgroundColor: theme.palette.brandPrimary.lightest,
        borderRadius: theme.spacing(0.75),
        borderWidth: 0,
        borderColor: 'transparent',
        width: theme.spacing(6),
        fontSize: 16,
        lineHeight: 1.5,
        textAlign: 'right',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
    },
}));

export const InlineQuantityControl: FC<InlineQuantityControlProps> = props => {
    const { fullWidth } = props;
    const classes = useStyles();
    return <input type="number" style={fullWidth ? { width: '100%' } : null} className={classes.input} {...props} />;
};
